import type { HTMLAttributes } from 'react';
import { clsx } from '../clsx';
import styles from './KeyboardHint.module.css';

export interface KeyboardHintProps extends HTMLAttributes<HTMLElement> {
  /** The key or chord as shown, e.g. "⌘K", "Esc", "↵". */
  keys: string;
  /** `small` is the badge inside the search trigger (10.5 px), `default` the "Esc" badge of the search dialog (11 px). */
  size?: 'small' | 'default' | undefined;
}

/** Keyboard shortcut badge (`⌘K` in the topbar search, `Esc` in the command palette). */
export function KeyboardHint({ keys, size = 'small', className, ...rest }: KeyboardHintProps) {
  return (
    <kbd className={clsx(styles.hint, size === 'default' && styles.default, className)} {...rest}>
      {keys}
    </kbd>
  );
}
